import { Component, Input } from '@angular/core';
import { UntypedFormBuilder, UntypedFormControl, UntypedFormGroup, ValidatorFn, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { LoginService } from '../../../../shared/pages/login/login.service';
import { PCodeServices } from '../../../../shared/services/pcode.service';

@Component({
    selector: 'reset-password-internal',
    templateUrl: './reset-password.component.html',
    standalone: false
})
export class ResetPasswordInternalComponent
{
    passwordRegex = '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[A-Za-z\d].{8,}';

    // input
    @Input() userId: string;

    // reset password form
    passwordFC = new UntypedFormControl('', [Validators.required, Validators.pattern(this.passwordRegex)]);
	confirmPasswordFC = new UntypedFormControl('', [Validators.required, Validators.pattern(this.passwordRegex), this.checkPasswordsValidator()]);
    public _resetPasswordForm: UntypedFormGroup = this.fb.group(
        {
            password: this.passwordFC,
            confirmPassword: this.confirmPasswordFC
        }
    );
    get password() { return this._resetPasswordForm.get('password'); }
    get confirmPassword() { return this._resetPasswordForm.get('confirmPassword'); }

    // constructor
    constructor(
        private pcodeServices: PCodeServices,
        private translateService: TranslateService,
        private fb: UntypedFormBuilder,
        private route: ActivatedRoute,
        private router: Router,
        private loginService: LoginService
    )
    {

    }

    // reset password
    onResetPassword()
    {
        if (this._resetPasswordForm.valid)
        {
            this.loginService.resetPasswordInternal(this.userId, this.password.value).subscribe(
                success =>
                {
                    this.pcodeServices.notify('success', this.translateService.instant('Modules.Users.Applications.Users.Notifications.ResetPassword'));
                },
                error =>
                {
                    // check: same password
                    if (error.error.changePassword)
                    {
                        this.pcodeServices.notify('error', this.translateService.instant('Modules.Login.ResetPassword.Notifications.Error.SameAsCurrent'));
                    }
                    else
                    {
                        this.pcodeServices.notify('error', error.message);
                    }
                }
            );
        }
	}

	// check passwords
	checkPasswordsValidator(): ValidatorFn
	{
		return () =>
		{
			if (this._resetPasswordForm)
			{
				const _password = this._resetPasswordForm.get('password').value;
				const _confirmPassword = this._resetPasswordForm.get('confirmPassword').value;

				if (_password !== _confirmPassword)
					return { equalTo: true };
				else
					return null
			}
			else
				return null;
		}
	}
}